/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file PsychosocialRiskView.jsx
 * @author Daniel Aguirre
 * @description PsychosocialRisk View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardCard from 'components/DashboardCard';
import { useHistory } from 'react-router';

import DashboardProgress from 'components/Charts/DashboardProgress';
import styleGuideColors from 'commons/styleGuideColors';

/**
 * PsychosocialRisk View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function PsychosocialRiskView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState(null);

  const { getPsychosocialRisk } = dashboardStaffActions;

  const getProgressData = (key, color, total) => {
    return {
      label: translate(`commons.${key.coinciden}`),
      value: ((key.cantidad * 100) / total).toFixed(3).slice(0, -1),
      color,
      cantidad: key.cantidad,
      classification: key.coinciden
    };
  };

  const onGetData = (_, resp) => {
    if (resp?.data && resp?.data?.length !== 0) {
      let data = {};
      let progress = {};
      let max = {};
      let total = 0;
      resp?.data.forEach(({ cantidad }) => {
        total += cantidad;
      });

      resp?.data?.forEach((itm) => {
        if (itm.coinciden === 'Si') {
          progress = getProgressData(
            itm,
            styleGuideColors.baxterBrandTeal,
            total
          );
        } else {
          max = getProgressData(itm, styleGuideColors.alertError, total);
        }
      });
      data = {
        progress,
        max
      };
      setChartData(data);
    } else {
      setChartData([]);
    }
  };

  useEffect(() => {
    getPsychosocialRisk({ clinicId }, onGetData);
  }, [translate, clinicId]);

  const handleDetailClick = (section) => {
    const { cantidad: totalItems, classification } = chartData[section];
    history.push(
      `/main/dashboard-detail/psychosocial-risk-list/${classification}/${totalItems}`
    );
  };

  return (
    <DashboardCard id="F35" loading={!chartData}>
      <DashboardProgress
        title={translate('dashboardStaff.psychosocialRisk')}
        max={chartData?.max}
        progress={chartData?.progress}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
PsychosocialRiskView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getPsychosocialRisk: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default PsychosocialRiskView;
